import React from "react";
import { Link } from "react-router-dom";
import { GlyphRow } from "@/components/Ornaments";
import { PageHead } from "@/components/PageHead";
import { Seo } from "@/components/Seo";
import type { LanguageBinding } from "@/hooks/useLanguage";
import { cx } from "@/lib/classnames";

export const Legacy: React.FC<{ language: LanguageBinding }> = ({ language }) => {
  const { t, lang, isRTL } = language;
  return (
    <>
      <Seo
        title={t.meta.legacy.title}
        description={t.meta.legacy.description}
        lang={lang}
        path="/legacy"
      />
      <PageHead kicker={t.legacyPage.kicker} title={t.legacyPage.title} isRTL={isRTL} />

      <section className="relative" style={{ background: "var(--ink-2)" }}>
        <div className="grain" />
        <div className="max-w-[900px] mx-auto px-6 md:px-10 py-20 md:py-24 relative">
          <div className="flex justify-center mb-6" style={{ color: "var(--gold)" }}>
            <GlyphRow color="currentColor" />
          </div>
          <div
            className={cx(
              isRTL ? "ff-ar-serif" : "ff-en-serif italic",
              "text-xl md:text-2xl leading-relaxed space-y-6 text-center",
            )}
            style={{ color: "var(--parchment)" }}
          >
            {t.legacyPage.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/contact"
              className={cx(
                isRTL ? "ff-ar-sans" : "ff-en-sc tracked-wide",
                "text-[13px] md:text-[14px] px-6 py-3.5 rounded-full",
              )}
              style={{ background: "var(--vermillion)", color: "#fff3df" }}
            >
              {t.legacyPage.cta1}
            </Link>
            <Link
              to="/concepts"
              className={cx(
                isRTL ? "ff-ar-sans" : "ff-en-sc tracked-wide",
                "text-[13px] md:text-[14px] px-6 py-3.5 rounded-full",
              )}
              style={{ color: "var(--parchment)", border: "1px solid var(--hairline-dark)" }}
            >
              {t.legacyPage.cta2}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};
